/* eslint-disable import/no-cycle */
import {AuthApi} from './endpoints/auth';
import {BatchesApi} from './endpoints/batches';
import {BatchGeneratorFunctionApi} from './endpoints/batchGeneratorFunctions';
import {BatchQueueItemsApi} from './endpoints/batchQueueItems';
import {ComponentsApi} from './endpoints/components';
import {ConsumptionsApi} from './endpoints/consumptions';
import {CockpitDashboardsApi} from './endpoints/cockpitDashboard';
import {CockpitsApi} from './endpoints/cockpits';
import {CockpitWidgetsApi} from './endpoints/cockpitWidgets';
import {CustomActionsApi} from './endpoints/customActions';
import {CustomFunctionsApi} from './endpoints/customFunctions';
import {CustomPropertiesApi} from './endpoints/customProperty';
import {DocumentsApi} from './endpoints/documents';
import {DocumentTypesApi} from './endpoints/documentTypes';
import {EventLogsApi} from './endpoints/eventLogs';
import {ExternalResourceApi} from './endpoints/externalResource';
import {HierarchyApi} from './endpoints/hierarchy';
import {IngredientsApi} from './endpoints/ingredients';
import {InspectionLotsApi} from './endpoints/inspectionLot';
import {InspectionPlansApi} from './endpoints/inspectionPlan';
import {InspectionTaskGroupsApi} from './endpoints/insepctionTaskGroup';
import {InspectionTaskResultsApi} from './endpoints/insepctionTaskResult';
import {InspectionTasksApi} from './endpoints/inspectionTask';
import {InspectionTasksPendingApi} from './endpoints/inspectionTasksPending';
import {InterruptionReasonsApi} from './endpoints/interruptionReasons';
import {InterruptionReasonSourcesApi} from './endpoints/interruptionReasonSources';
import {KeyPerformanceIndicatorApi} from './endpoints/keyPerformanceIndicator';
import {KeyPerformanceIndicatorExportTemplateApi} from './endpoints/keyPerformanceIndicatorExportTemplate';
import {KeyPerformanceIndicatorTargetApi} from './endpoints/keyPerformanceIndicatorTarget';
import {LdapConnectionApi} from './endpoints/ldapConnection';
import {LdapFieldMappingsApi} from './endpoints/ldapFieldMappings';
import {LdapGroupsApi} from './endpoints/ldapGroups';
import {MaterialsApi} from './endpoints/materials';
import {MaterialSensorApi} from './endpoints/materialSensors';
import {MesConfigApi} from './endpoints/mesConfig';
import {MessageDocumentsApi} from './endpoints/messageDocuments';
import {MessageReadsApi} from './endpoints/messageReads';
import {OperationPhasesApi} from './endpoints/operationPhases';
import {MessagesApi} from './endpoints/messages';
import {ObjectLocksApi} from './endpoints/objectLocks';
import {OperationPhaseLogsApi} from './endpoints/operationPhaseLogs';
import {OperationsApi} from './endpoints/operations';
import {OperationStateLogsApi} from './endpoints/operationStateLogs';
import {OperationStatesApi} from './endpoints/operationStates';
import {OrdersApi} from './endpoints/orders';
import {PermissionsApi} from './endpoints/permissions';
import {PersonnelLogsApi} from './endpoints/personnel';
import {PhasesApi} from './endpoints/phases';
import {PreparationsApi} from './endpoints/preparations';
import {RelevantMessagesApi} from './endpoints/relevantMessages';
import {ReportLogsApi} from './endpoints/reportLogs';
import {ReportTypesApi} from './endpoints/reportTypes';
import {RolesApi} from './endpoints/roles';
import {SensorDataApi} from './endpoints/sensorData';
import {SensorDataTargetApi} from './endpoints/sensorDataTarget';
import {SensorsApi} from './endpoints/sensors';
import {SettingsApi} from './endpoints/settings';
import {ShiftBooksApi} from './endpoints/shiftBooks';
import {ShiftsApi} from './endpoints/shifts';
import {StateHistoriesApi} from './endpoints/stateHistories';
import {StorageUnitsApi} from './endpoints/storageUnits';
import {TerminalLayoutsApi} from './endpoints/terminalLayouts';
import {TerminalsApi} from './endpoints/terminals';
import {TransitionsApi} from './endpoints/transitions';
import {UnitOfMeasurementConversionsApi} from './endpoints/unitOfMeasurementConversion';
import {UnitsOfMeasurementApi} from './endpoints/unitsOfMeasurement';
import {UserRolesApi} from './endpoints/userRoles';
import {UsersApi} from './endpoints/users';
import {WorkflowCorrectionsApi} from './endpoints/workflowCorrections';
import {WorkflowsApi} from './endpoints/workflows';
import {WorkplacesApi} from './endpoints/workplaces';
import {WorkplaceStateLogsApi} from './endpoints/workplaceStateLogs';
import {WorkplaceGroupsApi} from './endpoints/workplaceGroups';
import {WorkplaceStatesApi} from './endpoints/workplaceStates';
import {YieldApi} from './endpoints/yields';
import {YieldTypesApi} from './endpoints/yieldTypes';

export const Api = {
  auth: AuthApi,
  batches: BatchesApi,
  batchGeneratorFunctions: BatchGeneratorFunctionApi,
  batchQueueItems: BatchQueueItemsApi,
  cockpitDashboards: CockpitDashboardsApi,
  cockpits: CockpitsApi,
  cockpitWidgets: CockpitWidgetsApi,
  components: ComponentsApi,
  consumptions: ConsumptionsApi,
  customActions: CustomActionsApi,
  customFunctions: CustomFunctionsApi,
  documents: DocumentsApi,
  documentTypes: DocumentTypesApi,
  eventLogs: EventLogsApi,
  externalResources: ExternalResourceApi,
  hierarchy: HierarchyApi,
  inspectionLot: InspectionLotsApi,
  ingredients: IngredientsApi,
  inspectionPlan: InspectionPlansApi,
  inspectionTask: InspectionTasksApi,
  inspectionTaskGroup: InspectionTaskGroupsApi,
  inspectionTaskResult: InspectionTaskResultsApi,
  inspectionTasksPending: InspectionTasksPendingApi,
  interruptionReasons: InterruptionReasonsApi,
  interruptionReasonSources: InterruptionReasonSourcesApi,
  keyPerformanceIndicator: KeyPerformanceIndicatorApi,
  keyPerformanceIndicatorExportTemplate: KeyPerformanceIndicatorExportTemplateApi,
  keyPerformanceIndicatorTarget: KeyPerformanceIndicatorTargetApi,
  ldapConnection: LdapConnectionApi,
  ldapFieldMappings: LdapFieldMappingsApi,
  ldapGroups: LdapGroupsApi,
  materials: MaterialsApi,
  materialSensors: MaterialSensorApi,
  mesConfig: MesConfigApi,
  messageDocuments: MessageDocumentsApi,
  messageReads: MessageReadsApi,
  messages: MessagesApi,
  objectLocks: ObjectLocksApi,
  operations: OperationsApi,
  operationPhaseLog: OperationPhaseLogsApi,
  operationPhases: OperationPhasesApi,
  operationStateLogs: OperationStateLogsApi,
  operationStates: OperationStatesApi,
  orders: OrdersApi,
  permissions: PermissionsApi,
  personnelLogs: PersonnelLogsApi,
  phases: PhasesApi,
  preparations: PreparationsApi,
  properties: CustomPropertiesApi,
  relevantMessages: RelevantMessagesApi,
  reportLogs: ReportLogsApi,
  reportTypes: ReportTypesApi,
  roles: RolesApi,
  sensorData: SensorDataApi,
  sensorDataTarget: SensorDataTargetApi,
  sensors: SensorsApi,
  settings: SettingsApi,
  shiftBooks: ShiftBooksApi,
  shifts: ShiftsApi,
  stateHistories: StateHistoriesApi,
  storageUnits: StorageUnitsApi,
  terminalLayouts: TerminalLayoutsApi,
  terminals: TerminalsApi,
  transitions: TransitionsApi,
  unitOfMeasurementConversions: UnitOfMeasurementConversionsApi,
  unitsOfMeasurement: UnitsOfMeasurementApi,
  users: UsersApi,
  userRoles: UserRolesApi,
  workflowCorrections: WorkflowCorrectionsApi,
  workflows: WorkflowsApi,
  workplaceGroups: WorkplaceGroupsApi,
  workplaces: WorkplacesApi,
  workplaceStateLogs: WorkplaceStateLogsApi,
  workplaceStates: WorkplaceStatesApi,
  yields: YieldApi,
  yieldTypes: YieldTypesApi,
};
